import { render, staticRenderFns } from "./spinner.vue?vue&type=template&id=b734ac0a&scoped=true"
import script from "./spinner.vue?vue&type=script&setup=true&lang=js"
export * from "./spinner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./spinner.vue?vue&type=style&index=0&id=b734ac0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b734ac0a",
  null
  
)

export default component.exports